// extracted by mini-css-extract-plugin
export default {"container":"LabList_container__YLaJu","pagination":"LabList_pagination__3LCmD"};